<template>
  <div class="row">
    <div class="px-3 py-3" v-for="(item, index) in newList" :key="index">
      <div class="rounded-border card-container card-shadow">
        <template v-if="item.imageUrl" name="foo">
          <div class="img__container">
            <img
              :src="item.imageUrl"
              class="rounded-border"
              v-if="item.title"
              @click="viewStoryDetail(item)"
            />
          </div>
          <div class="actions__bloc" v-if="activeActionsList == index">
              <GalleryActions :actions="actions" :story="item" @clicked="toggleActions(index,item)"/>
          </div>

          <div
            :id="'contextMenu' + index"
            v-if="activeActionsList == index && 1==-1"
            class="context-menu"
          >
            <ul class="menu">
              <li class="preview">
                <a @click.stop="goDecisionTree(item)"
                ><i class="fas fa-divide"></i> Decision Tree</a
                >
              </li>
              <li class="preview">
                <a href="#"
                ><i class="fas fa-eye" aria-hidden="true"></i> Preview</a
                >
              </li>
              <li class="share">
                <a @click.stop="shareStory(item)"
                ><i class="fa fa-share" aria-hidden="true"></i> Share</a
                >
              </li>
              <li class="getLink">
                <a @click.stop="copyLink(item)"
                ><i class="fa fa-link" aria-hidden="true"></i> Get link</a
                >
              </li>
              <li class="location">
                <a href="#"
                ><i class="fa fa-file" aria-hidden="true"></i> Show file
                  location</a
                >
              </li>
              <li class="starred">
                <a v-if="!item.isStarred" @click.stop="addToStarred(item)"
                ><i class="far fa-star" aria-hidden="true"></i> Add to
                  Starred</a>
                <a v-if="item.isStarred" @click.stop="removeFromStarred(item)"
                ><i class="fa fa-star" aria-hidden="true"></i> Remove from
                  Starred</a>
              </li>
              <li class="rename">
                <a href="#"
                ><i class="fas fa-pen" aria-hidden="true"></i> Rename</a
                >
              </li>
              <li class="copy">
                <a @click.stop="copyStory(item)"
                ><i class="fa fa-copy" aria-hidden="true"></i>Make a copy</a
                >
              </li>
              <li class="edit">
                <a @click.stop="editStoryInfo(item)"
                ><i class="fa fa-edit" aria-hidden="true"></i> Edit</a
                >
              </li>
              <li class="trash">
                <a @click.stop="deleteStory(item)"
                ><i class="fa fa-trash" aria-hidden="true"></i> Delete</a
                >
              </li>
              <li class="download">
                <a @click.stop="downloadStory(item)"
                ><i class="fa fa-download" aria-hidden="true"></i> Download</a
                >
              </li>
            </ul>
          </div>
        </template>
        <div class="pt-3">
          <div class="row">
            <div class="col-6">
              <h6 v-if="item.title" @click="viewStoryDetail(item)">
                {{ item.title }} 
              </h6>
            </div>
            <div class="col-6 text-right">
               <span class="" title="shared with me" v-if="item.sharedWith && item.sharedWith.includes($store.state.user.id)"><svg version="1.1" fill="currentColor" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve"><path fill="currentColor" d="M12.996,10.037c-0.743,0-1.413,0.308-1.893,0.802L5.627,8.277C5.636,8.186,5.641,8.094,5.641,8S5.636,7.814,5.627,7.723l5.476-2.562c0.48,0.494,1.15,0.802,1.893,0.802c1.457,0,2.639-1.181,2.639-2.64c0-1.457-1.182-2.639-2.639-2.639c-1.458,0-2.639,1.182-2.639,2.639c0,0.094,0.005,0.186,0.014,0.277L4.895,6.163c-0.48-0.494-1.15-0.802-1.893-0.802C1.545,5.361,0.364,6.543,0.364,8c0,1.458,1.182,2.639,2.639,2.639c0.743,0,1.414-0.308,1.893-0.802l5.476,2.562c-0.009,0.091-0.014,0.183-0.014,0.277c0,1.457,1.181,2.639,2.639,2.639c1.457,0,2.639-1.182,2.639-2.639S14.454,10.037,12.996,10.037z"></path></svg></span>
               <span class="" v-if="item.isStarred" title="starred"><i class="fa fa-star"></i></span>
            </div>
          </div>
          <div class="text-gray" v-if="item.author">
            <img src="~@/assets/icons/AuthorGray.svg" width="20px">
            <small class="ml-1" v-if="item.author">{{ item.author }}</small>
          </div>
          <div class="text-gray d-flex justify-content-between my-2">
            <div class="align-middle">
              <img src="~@/assets/icons/Date.svg" width="20px">
              <small class="ml-1" v-if="item.date">{{ item.date }}</small>
            </div>
            <div class="text-right">
              
              <button type="button" class="btn list-btn rounded-border p-1" :class="{'btn-active' : activeActionsList == index}"  @click="toggleActions(index,item)">
                <img class="default-icon" src="~@/assets/icons/list.svg" width="20px">
                <img class="icon-white" src="~@/assets/icons/list-white.svg" width="20px">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- right click dialog START-->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card v-if="getLink">
        <v-card-text>
          <v-container grid-list-sm style="padding-top: 0px;padding-bottom:0px">
            <h4><i class="fa fa-link"></i> GET LINK</h4>
            <v-text-field
              v-model="copyLinkAddress"
              label="Copy Link"
              id="copyUrl"
            ></v-text-field>
            <a v-on:click="copyUrl()">Copy link</a>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_share" max-width="500px">
      <v-card v-if="share">
        <v-card-text>
          <v-container grid-list-sm style="padding-top: 0px">
            <h4><svg version="1.1" fill="currentColor" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve"><path fill="currentColor" d="M12.996,10.037c-0.743,0-1.413,0.308-1.893,0.802L5.627,8.277C5.636,8.186,5.641,8.094,5.641,8S5.636,7.814,5.627,7.723l5.476-2.562c0.48,0.494,1.15,0.802,1.893,0.802c1.457,0,2.639-1.181,2.639-2.64c0-1.457-1.182-2.639-2.639-2.639c-1.458,0-2.639,1.182-2.639,2.639c0,0.094,0.005,0.186,0.014,0.277L4.895,6.163c-0.48-0.494-1.15-0.802-1.893-0.802C1.545,5.361,0.364,6.543,0.364,8c0,1.458,1.182,2.639,2.639,2.639c0.743,0,1.414-0.308,1.893-0.802l5.476,2.562c-0.009,0.091-0.014,0.183-0.014,0.277c0,1.457,1.181,2.639,2.639,2.639c1.457,0,2.639-1.182,2.639-2.639S14.454,10.037,12.996,10.037z"></path></svg> Share</h4>
            <div>
             <multiselect
                        v-model="sharedWith"
                        :options="people"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :taggable="false"
                        :multiple="true"
                        placeholder="Add people to share with"
                        :clear-on-select="false" 
                        :preserve-search="true" 
                        label="firstName" 
                        :custom-label="fullName"
                        track-by="email" 
                        :max-height="160"
                        :preselect-first="false"
                  ></multiselect>
                  </div>
          </v-container>
        </v-card-text>
         <v-divider></v-divider>
        <v-card-actions>
          <button disabled  class="tablink">
                    <i class="fa fa-file"></i>
                     {{this.storyName}}
                  </button>
          <v-spacer></v-spacer>
          <v-btn v-if="showSaveButton" color="primary" @click="send">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Send</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- right click dialog END-->
  </div>
</template>

<script>
import GalleryActions from '../global/sections/GalleryActions.vue'
import Multiselect from "vue-multiselect";
import {db} from '../../firebaseDB'

export default {
  name: 'gridCard1',
  props: ['newList'],
  components: { GalleryActions,Multiselect},
  data () {
      return{
          contextRightMenu: false,
          optionsIndexVal: 0,
          dialog: false,
          people:[],
          saving: false,
          sharedWith:[],
          dialog_share:false,
          getLink: false,
          showSaveButton:true,
          share:false,
          storyName:'',
          story:'',
          activeActionsList : null,
          isStarred : true,
          actions : [
                        {
                            icon : "decisionTree",
                            name : "Decision Tree",
                            action : this.goDecisionTree(),
                            avaible : false
                        },
                        {
                            icon : "preview",
                            name : "Preview",
                            action : function(){},
                            avaible : false
                        },
                        {
                            icon : "share",
                            name : "Share",
                            action : this.shareStory(),
                            avaible : true
                        },
                        // {
                        //       icon : null,
                        //       name : "show file location",
                        //       action : function(){},
                        //       avaible : false
                        //   },
                          {
                              icon : "rename",
                              name : "Rename",
                              action : function(){},
                              avaible : false
                          },
                           {
                              icon : "download",
                              name : "Download",
                              action : this.downloadStory(),
                              avaible : true
                            },
                            {
                                icon : "edit",
                                name : "Edit",
                                action : this.editStoryInfo(),
                                avaible : false
                            },
                          {
                              icon : "copy",
                              name : "Make a copy",
                              action : this.copyStory(),
                              avaible : true
                          },
                        {
                            icon : "getlink",
                            name : "Get link",
                            action : this.copyLink(),
                            avaible : true
                        },
                        {
                            icon : "noStarred",
                            size : { width : 16, height : 16},
                            name : "add to Starred",
                            action : this.addToStarred(),
                            avaible : true
                        },
                        {
                            icon : "delete",
                            name : "Delete",
                            action : this.deleteStory(),
                            avaible : true
                        },
                      
                    ]
      }
  },
  watch: {},
  mounted () {
    window.addEventListener('click', this.closeRightClick)
  },
  computed: {
    storyGridClass () {
      if (this.$route.name == 'storylist') {
        return 'col-2'
      } else {
        return 'col-sm-12 col-md-4 col-xl-3'
      }
    },
  },
   watch : {
    isStarred(){
      let index = this.actions.findIndex(item => ["add to Starred","remove from starred"].includes(item.name))
      if(this.isStarred) {
        this.actions[index].icon = "starred"
        this.actions[index].name = "remove from starred"
        }
      else {
        this.actions[index].icon = "noStarred"
        this.actions[index].name = "add to Starred"
        }
    },
    '$store.state.modelOpened'(value) {
      if(!value) this.activeActionsList = null
    }
  },

  methods: {
     fullName ({ firstName, lastName , email }) {
      return `${firstName}  ${lastName} - ${email}`
    },
    toggleActions(cardIndex,story){
      this.isStarred = story.isStarred;
      if(this.activeActionsList == cardIndex) this.activeActionsList = null;
      else this.activeActionsList = cardIndex
      this.$store.state.modelOpened = this.activeActionsList != null ?  true : false;
    },
    deleteStory (story) {
      return (story) => {
        this.contextRightMenu = false
        this.$emit('deleteStory', story)
      }
    },
    editStoryInfo (story) {
      return (story) => {
        localStorage.setItem('storyId', story.id)
        this.contextRightMenu = false
        this.$emit('editStoryInfo', story)
      }
    },
    copyStory (story) {
        return (story) => {
          this.contextRightMenu = false
          this.$emit('copyStory', story)
        }
    },
    shareStory (story) {
        return (story) => { 
          this.sharedWith = []
          this.people=[]
        this.contextRightMenu = false;
        this.contextRightMenu = false
        this.dialog_share = true
        this.share = true
        this.storyName = story.title
        this.story = story
      db.ref(`users`)
      .once('value')
      .then(snapshot => {
        let entries = Object.entries(snapshot.val())
          for (let entry of entries) {
            if(entry[1].firstName && entry[1].lastName && entry[1].userId && entry[1].email){
              this.people.push(entry[1])
            }
          }
      })
        }
    },
    send(){
     let storyKey = this.story.id
       db.ref(`stories/${storyKey}`).once('value').then(snapshot => {
         let Story =snapshot.val()
        if(!Story.sharedWith){
           Story.sharedWith = [];
         }
        this.sharedWith.forEach(element => {
         Story.sharedWith.push(element.userId)
            })
         db.ref().child(`stories/${storyKey}`).update(Story)
       })
        this.dialog_share = false
        this.share = false
    },  
      goDecisionTree (story) { 
      console.log("mactions---------");
    //  return (story) => { this.$router.push({name: 'storyEditView', params: {title: story.title}, query: {id: story.id}})}
     return (story) => {}
    },
    downloadStory (story){
      return (story) => {
        this.contextRightMenu = false
        this.$emit('downloadStory', story)
      }
    },
    copyLink (story) {
      return (story) => { 
        this.contextRightMenu = false;
        this.contextRightMenu = false
        this.dialog = true
        this.getLink = true
        this.copyLinkAddress =
        location.host +
        '/storyEditView/' +
        story.title +
        '?' +
        'id' +
        '=' +
        story.id}
    },
    addToStarred (story) {
      this.isStarred = !this.isStarred
       return (story) =>{
         if(!story.isStarred) this.$emit('addToStarred', story);
         else this.$emit('removeFromStarred', story)
        }
    },
    removeFromStarred (story) {
      this.$emit('removeFromStarred', story)
    },
    copyUrl () {
      return (story) => {
        const copyText = document.getElementById('copyUrl')
        copyText.select()
        copyText.setSelectionRange(0, 99999)
        document.execCommand('copy')

      }
    },
    viewStoryDetail (story) {
      localStorage.setItem('storyId', story.id)
      this.$emit('viewStoryDetail', story)
    },
    handler: function (e, index) {
      this.showActions = !this.showActions;
      console.log("actions-->",this.showActions);
      this.contextRightMenu = true
      this.optionsIndexVal = index
      e.preventDefault()
    },
    closeRightClick: function (e) {
      this.contextRightMenu = false;

    },
  },
}
</script>

<style lang="scss" scoped>
.card-shadow {
  border: 1px #919191;
  box-shadow: -1px 1px 6px -1px rgba(0, 0, 0, 0.171);
  /* overflow: hidden; */
}

.cls-context-menu ul li {
  list-style: none;
}

.cls-context-menu ul {
  float: right;
  top: 20px;
  z-index: 9999;
  margin-top: -100px;
  background-color: #fff;
}

.context-menu {
    position: absolute;
    left: 20%;
    top: -20px;
    width: 220px;
    z-index: 1000;
}

.menu {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  // box-shadow: 0 10px 20px rgb(64 64 64 / 5%);
  padding: 10px 0;
}

.menu > li {
  list-style: none;
}

.menu > li > a {
  font: inherit;
  border: 0;
  padding: 10px 30px 10px 15px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  text-decoration: unset;
  color: #000;
  font-weight: normal;
  transition: 0.5s linear;
  -webkit-transition: 0.5s linear;
  -moz-transition: 0.5s linear;
  -ms-transition: 0.5s linear;
  -o-transition: 0.5s linear;
}

.menu > li > a:hover {
  background: #f1f3f7;
  color: #4b00ff;
}

.menu > li > a > i {
  padding-right: 10px;
}

.menu > li.trash > a:hover {
  color: red;
}

.rounded-border {
  border-radius: 5px;
}

.card-container {
  padding: 15px;
  height: 100%;
  position: relative;
  cursor: pointer;
  // &:hover {
  //   opacity: .8;
  // }
}
 
.text-gray {
  color: #919191;
}

.list-btn {
  border-radius: 5px;
  position : relative;
  z-index: 2;
}
.list-btn:hover {
    background-color: #4d66b1;
}
.list-btn:hover .default-icon,
.list-btn .icon-white {
    display: none;
}
.list-btn:hover .icon-white {
    display: inline;
}
.btn-active {
  background-color: #4d66b1;
  .icon-white {
    display: inline;
  }
  .default-icon {
    display: none
  }
}
 .card {
   border : none;
   background-color : transparent ;
 }

 //fixed ipad cards
.pb-3, .py-3 {
max-width: 300px;
}

.img__container{
    height: calc(100vw / 10);
    width: 100%;
   img { 
     width : 100%;
     height : 100%;
     object-fit : cover;
   }
}
 .actions__bloc {
    position : absolute;
    top: 28%;
    right: 4.5rem;
    z-index: 2;
 }

  @media (max-width: 1220px) {
    // .card-container {
    //   max-width: 670px;
    // }
    .img__container{
      height: calc(100vw/5);
     }
  }
  @media (max-width: 820px) {
    .card-container {
      width: 100%;
    }
    .img__container{
      height: 21rem;
     }
  }
  .tablink {
     border-radius: 10px; 
     border: 1px solid #cecece; 
     padding: 6px 10px; 
     color: #000; 
}.multiselect {
    margin-bottom: 80px;
}
.hr {
   margin-bottom: 0rem; 
}
.shared{
    padding: 0.5rem 1rem;
    margin-right: 0.5rem;
    font-size: .9rem;
    border-radius: 0.2rem;
    background-color: #B9C4E1;
    color: #000;
    font-weight: 400;
    text-align: center;
    -webkit-transition: .2s;
    transition: .2s;
}
</style>



// WEBPACK FOOTER //
// src/components/story-list-view/gridCard1.vue